import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Category, SupplierMapping } from '@synergy/models';

export class SupplierCategoryMappingApi {
    constructor(protected baseUrl: string) {}

    public getCategoryMapping(supplierId: number): Promise<ApiResult<SupplierMapping<Category>[]>> {
        return safeRequest(
            () => {
                return request.get<PaginatedResponse<SupplierMapping<Category>>>(
                    `${this.baseUrl}/suppliers/${supplierId}/categories/mapping`,
                    {
                        params: new URLSearchParams({ limit: '15000' }),
                    }
                );
            },
            response => {
                return response.data.items;
            }
        );
    }

    public updateCategoryMapping(
        supplierId: number,
        categoryMapping: SupplierMapping<Category>
    ): Promise<ApiResult<SupplierMapping<Category>>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/suppliers/${supplierId}/categories/${categoryMapping.id}/mapping`, {
                    values: categoryMapping.supplierMapping,
                }),
            response => response.data
        );
    }
}
